import React, { useEffect, useState } from 'react';
import { Input, Button, DatePicker, notification, Dropdown, Menu, Carousel, message, Layout, Row, Col } from 'antd';
import { SwapOutlined, CarOutlined, CopyOutlined } from '@ant-design/icons';
import axios from 'axios';
import backgroundImage from '../../assets/banner_banner.png';
import { Link, useNavigate } from 'react-router-dom';
import './Home.css';
import playstore from '../../assets/playStore.svg'
import appstore from '../../assets/appStore.svg'
import QR from '../../assets/qrCode.svg'

const backend_url = process.env.REACT_APP_BACKEND_URL;
const { Footer } = Layout;

function Home() {
















  const backgroundStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '65vh',
    width: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    backgroundBlendMode: 'overlay',
  };

  const [toCity, setToCity] = useState('');
  const [fromCity, setFromCity] = useState('');
  const [date, setDate] = useState(null);
  const [stations, setStations] = useState([]);
  const [filteredStations, setFilteredStations] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownType, setDropdownType] = useState(''); // 'to' or 'from'

  const handleReverse = () => {
    setToCity(fromCity);
    setFromCity(toCity);
  };






  const couponData = [
    {
      image: 'https://via.placeholder.com/150',
      discount: 20,
      code: 'SAVE20',
      bgColor: '#ffcccc',
    },
    {
      image: 'https://via.placeholder.com/150',
      discount: 30,
      code: 'SAVE30',
      bgColor: '#ccffcc',
    },
    {
      image: 'https://via.placeholder.com/150',
      discount: 50,
      code: 'SAVE50',
      bgColor: '#ccccff',
    },
    {
      image: 'https://via.placeholder.com/150',
      discount: 10,
      code: 'SAVE10',
      bgColor: '#ffffcc',
    },
    {
      image: 'https://via.placeholder.com/150',
      discount: 25,
      code: 'SAVE25',
      bgColor: '#ccffff',
    },
    {
      image: 'https://via.placeholder.com/150',
      discount: 40,
      code: 'SAVE40',
      bgColor: '#ffccff',
    },
    {
      image: 'https://via.placeholder.com/150',
      discount: 15,
      code: 'SAVE15',
      bgColor: '#ffddcc',
    },
    {
      image: 'https://via.placeholder.com/150',
      discount: 35,
      code: 'SAVE35',
      bgColor: '#ddffcc',
    },
    {
      image: 'https://via.placeholder.com/150',
      discount: 45,
      code: 'SAVE45',
      bgColor: '#ccdfff',
    },
  ];




  const copyToClipboard = (code) => {
    navigator.clipboard.writeText(code);
    message.success(`Copied ${code} to clipboard!`);
  };












  useEffect(() => {
    axios.get(`${backend_url}/stations`)
      .then(response => {
        setStations(response.data);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, []);

  useEffect(() => {
    if (toCity || fromCity) {
      const filtered = stations.filter(station =>
        (toCity && (
          station.mainStation.toLowerCase().includes(toCity.toLowerCase()) ||
          station.subStations.some(subStation =>
            subStation.toLowerCase().includes(toCity.toLowerCase())
          )
        )) ||
        (fromCity && (
          station.mainStation.toLowerCase().includes(fromCity.toLowerCase()) ||
          station.subStations.some(subStation =>
            subStation.toLowerCase().includes(fromCity.toLowerCase())
          )
        ))
      );
      setFilteredStations(filtered);
      setDropdownOpen(filtered.length > 0);
    } else {
      setFilteredStations([]);
      setDropdownOpen(false);
    }
  }, [toCity, fromCity, stations]);

  const handleMenuClick = (value) => {
    if (dropdownType === 'to') {
      setToCity(value);
    } else {
      setFromCity(value);
    }
    setDropdownOpen(false);
  };

  const createMenuItems = () => {
    return filteredStations.flatMap(station => [
      <Menu.ItemGroup key={station._id} title={<strong>{station.mainStation}</strong>}>
        {station.subStations.map(subStation => (
          <Menu.Item
            key={`${station.mainStation}: ${subStation}`}
            onClick={() => handleMenuClick(`${station.mainStation}, ${subStation}`)}
          >
            {subStation}
          </Menu.Item>
        ))}
      </Menu.ItemGroup>
    ]);
  };

  const navigate = useNavigate();

  const searchmybus = () => {
    if (!toCity || !fromCity || !date) {
      notification.error({
        message: 'All Fields Mandatory',
      });
    } else {
      const filterData = {
        toCity,
        fromCity,
        date: date.$d,
      };
      navigate('/all-buses', { state: { filter: filterData } });
    }
  };





  return (
    <div className="home bg-gray-200" >


      {/* searching Bus start*/}

      <div className='h-[50vh]' style={backgroundStyle}>

        <h1 className="text-white md:text-[30px] text-[22px] text-center py-10 h-36">
          Welcome to n-bus | the leading ticket booking site
        </h1>


        <div className='flex flex-col md:flex-row md:justify-center justify-around md:h-auto h-[30vh] items-center'>
          <Dropdown
            overlay={<Menu>{createMenuItems()}</Menu>}
            visible={dropdownOpen && dropdownType === 'from'}
            onVisibleChange={(open) => setDropdownOpen(open)}
            trigger={['click']}
          >
            <Input
              prefix={<CarOutlined className='text-black-500' />}
              value={fromCity}
              onChange={(e) => {
                setFromCity(e.target.value);
                setDropdownType('from');
              }}
              placeholder="From City"
              className='md:desktopInput mobileInput md:rounded-l-3xl md:rounded-r-none  md:border-2 md:border-black md:border-r-0'
            />
          </Dropdown>

          <Button
            icon={<SwapOutlined />}
            onClick={handleReverse}
            className='bg-black text-white md:rotate-0 rotate-90  md:left-[33vw] left-[75vw] md:top-auto top-[45vh] absolute z-20 rounded-full'
          />

          <Dropdown
            overlay={<Menu>{createMenuItems()}</Menu>}
            visible={dropdownOpen && dropdownType === 'to'}
            onVisibleChange={(open) => setDropdownOpen(open)}
            trigger={['click']}
          >
            <Input
              prefix={<CarOutlined className='text-black-500' />}
              value={toCity}
              onChange={(e) => {
                setToCity(e.target.value);
                setDropdownType('to');
              }}
              placeholder="To City"
              className='md:desktopInput mobileInput md:rounded-none md:pl-5 p-3'
            />
          </Dropdown>

          <DatePicker
            value={date}
            onChange={(date) => setDate(date)}
            placeholder="Select Date"
            className='md:desktopInput mobileInput md:rounded-none'
          />

          <Button onClick={searchmybus} type="primary" className='md:desktopButton mobileButton md:rounded-r-3xl  bg-red-500 text-white font-bold text-lg'>
            Search
          </Button>
        </div>


      </div>


      {/* search bus end */}


      {/* Coupon start */}

      <div className="w-11/12 md:w-4/5 lg:w-7/10 -mt-5 md:-mt-20 mx-auto h-56 bg-white rounded-3xl shadow-md py-6  ">
        <Carousel
          autoplay
          arrows
          // prevArrow={<LeftOutlined className="font-black" />}
          // nextArrow={<RightOutlined className="font-black" />}
          responsive={[
            {
              breakpoint: 2024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },

          ]}
        >
          {couponData.map((coupon, index) => (
            <div key={index} className="flex justify-center py-5">
              <div
                className="flex items-center p-4  rounded-lg max-w-xs w-full mx-auto"
                style={{ backgroundColor: coupon.bgColor }}
              >
                <img
                  src={coupon.image}
                  alt="Discount"
                  className="w-1/4 rounded-lg"
                />
                <div className="ml-4">
                  <h2 className="text-xl font-bold">{coupon.discount}% OFF</h2>
                  <p className="text-sm">
                    Use Coupon Code: <strong>{coupon.code}</strong>
                  </p>
                  <Button
                    type="primary"
                    icon={<CopyOutlined />}
                    onClick={() => copyToClipboard(coupon.code)}
                  >
                    Copy Code
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>






      {/* Coupon end */}




      {/* information to n-rail start */}





      <div className="n-rail flex flex-col md:flex-row items-center mt-[15vh] mb-[20vh] w-[90vw] mx-auto">
        {/* Text Content Section */}
        <div className="text-content w-full md:w-1/2 p-6 flex flex-col h-auto md:h-[80vh] justify-around">
          <h1 className="text-xl md:text-[25px] leading-relaxed text-center font-bold mb-4 text-gray-800">
            NOW, GET MORE THAN JUST BUS TICKETS WITH THE n-Bus!
          </h1>
          <p className="text-gray-800 md:font-semibold font-medium mb-4 md:text-xl text-base tracking-wider">
            Book IRCTC Train Tickets on redRail. Enjoy a simple & superfast booking process with no service fee + no payment gateway charge.
          </p>

          <div className="bg-white p-4 md:p-6 lg:p-8 rounded-lg shadow-lg w-full max-w-sm md:max-w-md mx-auto md:mx-0">
            <h3 className="text-lg md:text-2xl font-bold text-gray-800 mb-4"><u>n-Train</u></h3>

            <div className="flex flex-col space-y-2 text-gray-700">
              <div className="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                <p className="font-semibold">Authorised IRCTC Partner</p>
              </div>

              <div className="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                <p className="font-semibold">Instant refunds on UPI payments</p>
              </div>

              <div className="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                <p className="font-semibold">Hassle-free customer support</p>
              </div>
            </div>
          </div>
        </div>

        {/* Trapezoid Background Container */}
        <div className="relative w-full md:w-[50vw] h-[40vh] md:h-[80vh] overflow-hidden mt-6 md:mt-0 trapezoid-shape">
          <div className="absolute inset-0 bg-gradient-to-b from-blue-100/60 to-red-900/60"></div>
          <img
            src={require('../../assets/n-rail.png')}
            alt="N-Rail"
            className="absolute inset-0 w-full h-full object-cover rounded-lg"
            style={{ aspectRatio: '16/9' }} // This maintains the aspect ratio
          />
        </div>
      </div>







      {/* information to n-rail end */}




      {/* App Promotoin Start */}







      <div className="mb-12 px-4">
        <div className="max-w-4xl mx-auto bg-gradient-to-r from-red-500 to-red-600 rounded-xl shadow-lg p-6 md:p-8 lg:p-10 flex flex-col md:flex-row items-center md:items-stretch space-y-6 md:space-y-0 md:space-x-10">
          {/* Left Section: Text and Features */}
          <div className="flex-1 bg-red-400 p-6 rounded-3xl shadow-md flex flex-col justify-between">
            <h2 className="text-3xl font-bold text-white mb-4 text-shadow">ENJOY THE APP!</h2>
            <ul className="mb-6 space-y-4">
              <li className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-green-500 mr-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span className="text-gray-800 text-lg">Quick access</span>
              </li>
              <li className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-green-500 mr-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span className="text-gray-800 text-lg">Superior live tracking</span>
              </li>
            </ul>

            <div className="flex justify-between text-center">
              <div>
                <p className="text-2xl font-bold text-white">
                  4.5 <span className="text-yellow-400">★</span>
                </p>
                <p className="text-sm text-white">50M+ downloads</p>
                <p className="text-sm text-white">Play Store</p>
              </div>
              <div>
                <p className="text-2xl font-bold text-white">
                  4.6 <span className="text-yellow-400">★</span>
                </p>
                <p className="text-sm text-white">50M+ downloads</p>
                <p className="text-sm text-white">App Store</p>
              </div>
            </div>
          </div>

          {/* Right Section: QR Code and App Store Links */}
          <div className="flex-1 flex flex-col items-center justify-center space-y-4">
            <p className="text-white font-semibold">Scan to download</p>
            <img
              src={QR}
              alt="QR Code"
              className="w-32 h-32 md:w-40 md:h-40 mb-4 rounded-lg border-4 border-white"
            />

            <p className="text-white font-semibold mb-2">Download the App on</p>
            <div className="flex space-x-4">
              <Link to="https://play.google.com" target="_blank" rel="noopener noreferrer">
                <img
                  src={playstore}
                  alt="Google Play Store"
                  className="h-12 transform transition hover:scale-105"
                />
              </Link>
              <Link to="https://apple.com" target="_blank" rel="noopener noreferrer">
                <img
                  src={appstore}
                  alt="Apple App Store"
                  className="h-12 transform transition hover:scale-105"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>






      {/* App Promotion end */}







      {/* Footer Start */}

      <hr className='border-t border-gray-300 my-6' />
      <Footer className="bg-gray-200 py-10 px-4">
        <Row gutter={[16, 16]} justify="center">
          {/* Column 1: About Us */}
          <Col xs={24} sm={12} md={6} lg={4}>
            <div className="text-center md:text-left">
              <h3 className="text-xl font-bold text-gray-900 mb-4">About Us</h3>
              <ul className="list-none space-y-2">
                <li>
                  <a href="#" className="text-gray-700 hover:text-blue-500 transition-colors">
                    Who We Are
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-700 hover:text-blue-500 transition-colors">
                    Our Story
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-700 hover:text-blue-500 transition-colors">
                    Careers
                  </a>
                </li>
              </ul>
            </div>
          </Col>

          {/* Column 2: Support */}
          <Col xs={24} sm={12} md={6} lg={4}>
            <div className="text-center md:text-left">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Support</h3>
              <ul className="list-none space-y-2">
                <li>
                  <a href="#" className="text-gray-700 hover:text-blue-500 transition-colors">
                    Help Center
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-700 hover:text-blue-500 transition-colors">
                    FAQs
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-700 hover:text-blue-500 transition-colors">
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
          </Col>

          {/* Column 3: Legal */}
          <Col xs={24} sm={12} md={6} lg={4}>
            <div className="text-center md:text-left">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Legal</h3>
              <ul className="list-none space-y-2">
                <li>
                  <a href="#" className="text-gray-700 hover:text-blue-500 transition-colors">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-700 hover:text-blue-500 transition-colors">
                    Terms of Service
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-700 hover:text-blue-500 transition-colors">
                    Cookie Policy
                  </a>
                </li>
              </ul>
            </div>
          </Col>

          {/* Column 4: Connect with Us */}
          <Col xs={24} sm={12} md={6} lg={4}>
            <div className="text-center md:text-left">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Connect with Us</h3>
              <ul className="list-none space-y-2">
                <li>
                  <a href="#" className="text-gray-700 hover:text-blue-500 transition-colors">
                    Facebook
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-700 hover:text-blue-500 transition-colors">
                    Twitter
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-700 hover:text-blue-500 transition-colors">
                    Instagram
                  </a>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Footer>










      {/* Footer End  */}











    </div>
  );
}

export default Home;
